interface Props {
  activeCount: number;
}

export default function LiveBar({ activeCount }: Props) {
  return (
    <div className="live-bar">
      <div className="live-bar-inner">
        <div className="live-indicator">
          <span className="live-dot" />
          <span className="live-label">Live</span>
        </div>
        <span className="live-count">
          <strong>{activeCount}</strong> detectives investigating now
        </span>
      </div>
    </div>
  );
}
